export var PNL_REPORT = "PNL_REPORT";
export var PNL_STOCK_DETAILS = "PNL_STOCK_DETAILS";
export var PNL_ERROR = "PNL_ERROR";
export var PNL_SHOW_SHIMMER = "PNL_SHOW_SHIMMER";
export var PNL_HIDE_ERROR = "PNL_HIDE_ERROR";
export var PNL_EMPTY_VALIDATION = "PNL_EMPTY_VALIDATION";
export var PNL_HIDE_EMPTY_VALIDATION = "PNL_HIDE_EMPTY_VALIDATION";
export var PROD_ASSET_FILTER_VAL = "PROD_ASSET_FILTER_VAL";
export var PNL_STREAM_TOGGLE = "PNL_STREAM_TOGGLE";
